import React, { useContext, useState, useEffect } from 'react'
import {
  IonContent,
  IonLabel,
  IonPage,
  IonSegment,
  IonSegmentButton,
  SegmentChangeEventDetail,
  useIonRouter,
  useIonViewWillEnter,
} from '@ionic/react'
import { CustomSpacer, StyleIonHeader } from '../../../components'
import { observer } from 'mobx-react-lite'
import { MainTradeList } from './MainTradeList'
import { StoresContext } from '../../../provider/StoreProvider'
import { RouteComponentProps } from 'react-router'
import { MainSaleList } from './MainSaleList'
import { MainTradeStatus } from './MainTradeStatus'
import { LIST_TYPE_MARKET } from '../../../common'

interface IonSegmentCustomEvent<T> extends CustomEvent<T> {
  detail: T
  target: HTMLIonSegmentElement
}

export const Main: React.FC<RouteComponentProps> = observer(() => {
  const { commonStore, marketStore, authStore } = useContext(StoresContext)
  const [listType, setListType] = useState<LIST_TYPE_MARKET>(LIST_TYPE_MARKET.SALE)
  const router = useIonRouter()

  useIonViewWillEnter(() => {
    commonStore.setShowTab(true)
    marketStore.salePagingStore.load(undefined, true)
    marketStore.tradePagingStore.load(undefined, true)
    // FIXME : route 또는 store에서 통합 처리할 수 있도록 수정 필요
    setTimeout(() => {
      if (authStore.userInfo?.status === 'NEED_REQUIRE_DATA_INPUT') {
        router.push('/signUp')
      }
    }, 300)

    // 트레이드 탭 표시 - 작품 상세 페이지에서 마켓 진입시 탭 변경
    if (commonStore.listTab === 'TRADE') {
      setListType(LIST_TYPE_MARKET.TRADE)
      return
    }
    if (commonStore.listTab === 'SALE') {
      setListType(LIST_TYPE_MARKET.SALE)
      return
    }
  })

  // 트레이드 탭 표시 - 페이지 변경시 스토어 값 초기화
  useEffect(() => {
    if (listType === 'SALE') {
      commonStore.setListTab('SALE')
    } else if (listType === 'TRADE') {
      commonStore.setListTab('TRADE')
    } else {
      commonStore.setListTab(listType)
    }
  }, [listType])

  const onSegmentChange = (e: IonSegmentCustomEvent<SegmentChangeEventDetail>) => {
    if (e.target.value !== 'SALE' && e.target.value !== 'TRADE' && e.target.value !== 'TRADE_STATUS') {
      return
    }
    setListType(LIST_TYPE_MARKET[e.target.value])
  }

  return (
    <IonPage>
      <StyleIonHeader type={'MAIN'} title={'MARKET'} rightItem={'ALARM'} />
      <IonContent>
        <IonSegment color="dark" value={listType} onIonChange={(e) => onSegmentChange(e)}>
          <IonSegmentButton value="SALE">
            <IonLabel>조각 투자</IonLabel>
          </IonSegmentButton>
          <IonSegmentButton value="TRADE">
            <IonLabel>트레이드</IonLabel>
          </IonSegmentButton>
          <IonSegmentButton value="TRADE_STATUS">
            <IonLabel>거래상태</IonLabel>
          </IonSegmentButton>
        </IonSegment>
        {listType === LIST_TYPE_MARKET.SALE && <MainSaleList />}
        {listType === LIST_TYPE_MARKET.TRADE && <MainTradeList />}
        {listType === LIST_TYPE_MARKET.TRADE_STATUS && <MainTradeStatus />}
        <CustomSpacer spacing="20px" />
      </IonContent>
    </IonPage>
  )
})
